import { toaster } from 'components/design-system/Toaster';
import { clientApiPost } from 'lib/api_helper';
import { Listing } from 'types';

type DuplicateListingBody = {
  activePricingModel: Listing['activePricingModel'];
  auctionInfo: Partial<Listing['auctionInfo']>;
};

export const duplicateListing = async (
  setIsLoading: (val: boolean) => void,
  listingId: number,
  changes: Partial<Listing['auctionInfo']>,
  openModalFn: () => void
) => {
  setIsLoading(true);
  try {
    await clientApiPost<Listing, DuplicateListingBody>(`/api/marketplace/duplicateListing?id=${listingId}`, {
      activePricingModel: 'AUCTION',
      auctionInfo: changes
    });

    openModalFn();
  } catch (error) {
    toaster.error('Creating auction failed. Please try again');
    console.log(error);
  } finally {
    setIsLoading(false);
  }
};
